// <Icon type="file-image" />
import React from 'react';
import { DocumentPlayer } from '@/packages/resource/components/DocumentPlayer';

interface ModelProps {
  model: any;
}

export default (props: ModelProps) => {
  const { model } = props;
  return <DocumentPlayer {...model} />;
};
